import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getAllUsers, updateUserBus } from "../../services";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useFormik } from "formik";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";

const Users = (props) => {
  const [usersList, setUsersList] = useState([]);
  const [updateUser, setUpdateUser] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);


  const loadUsers = () =>{
    getAllUsers().then((response) => {
      setUsersList(response.data);
    });
  }

  const formik = useFormik({
    initialValues: {
      id: "",
      busNumber: 0,
    },
    validate: (data) => {
      let errors = {};

      if (!data.busNumber) {
        errors.busNumber = "Bus Number is required.";
      }else if (data.busNumber < 0 || data.busNumber > 33){
        errors.busNumber = "Bus Number must be between 1 - 33 only";
      }

      return errors;
    },
    onSubmit: (data) => {
      updateUserBus(data).then((response) => {
        loadUsers();
        setUpdateUser(false);
      });
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const updateUserHandler = (item) => {
    formik.setValues({ busNumber: item.bus_number, id: item.id });
    setUpdateUser(true);
  };

  return (
    <React.Fragment>
      <DataTable value={usersList} responsiveLayout="scroll">
        <Column field="name" header="Name"></Column>
        <Column field="email" header="Email"></Column>
        <Column field="city" header="City"></Column>
        <Column field="country" header="Country"></Column>
        <Column
          field="location"
          header="Location"
          body={(rowData) => (
            <a href={rowData.location} rel="noreferrer" target="_blank">
              Location
            </a>
          )}
        ></Column>
        <Column
          field="meters"
          header="# Meters"
          body={(rowData) => rowData.meters.length}
        ></Column>
        <Column field="bus_number" header="Bus Number"></Column>
        <Column
          field="actions"
          header=""
          body={(rowData) => {
            return (
              <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-secondary p-button-outlined"
                aria-label="Edit"
                onClick={() => updateUserHandler(rowData)}
              />
            );
          }}
        ></Column>
      </DataTable>

      <Dialog
        header="Update Bus Number"
        visible={updateUser}
        style={{ width: "50vw" }}
        footer={null}
        onHide={() => setUpdateUser(false)}
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid">
          <div className="field">
            <label
              className={classNames({
                "p-error": isFormFieldValid("busNumber"),
              })}
            >
              Bus Number
            </label>
            <span className="p-float-label">
              <InputNumber
                name="busNumber"
                id="busNumber"
                onBlur={formik.handleBlur}
                value={formik.values.busNumber}
                onChange={(e) => formik.setFieldValue("busNumber",e.value)}
                className={classNames({
                  "w-100": true,
                  "p-invalid": isFormFieldValid("busNumber"),
                })}
              />
            </span>
            {getFormErrorMessage("busNumber")}
          </div>

          <div className="mt-4 mb-2 d-flex justify-content-center">
            <Button type="submit" label="Submit" className="mt-2" />
          </div>
        </form>
      </Dialog>
    </React.Fragment>
  );
};

export default Users;
